import React from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { QUERY_KEYS } from "constant/react_query";
import { PanelResult } from "common/panel/dto/PanelResult";
import { panelFormDefaultValuesGet } from "common/panel/panel_form_common";
import { useUnosPanelUpdate } from "hooks/unos/panel/useUnosPanelUpdate";
import PanelForm from "components/common/panel/PanelForm";
import PanelSingleNav from "components/common/panel/PanelSingleNav";
import { title } from "process";

type PanelEditProps = {
  panel: PanelResult;
};

const PanelEdit = ({ panel }: PanelEditProps) => {
  const { handleSubmit, reset, control, setValue } = useForm({
    defaultValues: panelFormDefaultValuesGet(panel),
  });
  const { panelUpdateMutate } = useUnosPanelUpdate({
    invalidateKeys: [QUERY_KEYS.UNOS_PANEL_SEARCH],
  });

  const onSubmit = async (data: any) => {
    console.log(data);
    const { datum, title, slug, areas } = data;
    console.log("datum", datum);
    panelUpdateMutate({
      id: panel.id,
      updatePayload: { datum, title, slug, areas },
    });
    toast.success("Panel updated");
  };

  return (
    <DivPanel>
      <DivTitle>{panel.title}</DivTitle>
      <PanelForm
        control={control}
        onSubmit={onSubmit}
        handleSubmit={handleSubmit}
        reset={reset}
        defaultValues={panelFormDefaultValuesGet(panel)}
        setValue={setValue}
      />
      <DivNav>
        <PanelSingleNav panel={panel} hideEditNav={true} hideDeleteNav={true} />
      </DivNav>
    </DivPanel>
  );
};

const DivPanel = styled.div`
  display: flex;
  flex-direction: column;
`;

const DivNav = styled.div`
  margin-top: 1rem;
`;

const DivTitle = styled.div`
  margin-top: 1rem;
`;

export default PanelEdit;
